import { openDB, IDBPDatabase } from 'idb';
import { DB_INSTANCE_NAME, DB_INSTANCE_VERSION, DB_INSTANCE_PN_STORE } from '@/src/helpers/constants/index.js';

export class Database {
    dbName: string;
    dbVersion: number;
    db: Promise<IDBPDatabase>;

    static dbInstanceName: string | null;
    static dbInstanceVersion: typeof DB_INSTANCE_VERSION;
    static dbInstance: Database | null;

    constructor(dbName: string, dbVersion: number) {
        this.dbName = dbName;
        this.dbVersion = dbVersion;
        this.db = openDB(this.dbName, this.dbVersion, {
            upgrade(db) {
                db.createObjectStore(DB_INSTANCE_PN_STORE);
            },
        });
    }

    static get singletonInstance(): Database {
        Database.dbInstanceName ??= DB_INSTANCE_NAME;
        Database.dbInstanceVersion ??= DB_INSTANCE_VERSION;
        if (!Database.dbInstance) {
            Database.dbInstance = new Database(Database.dbInstanceName, Database.dbInstanceVersion);
        }

        return Database.dbInstance;
    }

    async get(key: IDBValidKey): Promise<string> {
        return (await this.db).get(DB_INSTANCE_PN_STORE, key);
    }

    async set(key: IDBValidKey, value: Record<string, unknown> | string | boolean | null): Promise<IDBValidKey> {
        return (await this.db).put(DB_INSTANCE_PN_STORE, value, key);
    }

    async delete(key: IDBValidKey): Promise<void> {
        return (await this.db).delete(DB_INSTANCE_PN_STORE, key);
    }

    async clear(): Promise<void> {
        return (await this.db).clear(DB_INSTANCE_PN_STORE);
    }

    async keys(): Promise<IDBValidKey[]> {
        return (await this.db).getAllKeys(DB_INSTANCE_PN_STORE);
    }

    static async get(key: IDBValidKey): Promise<string> {
        return Database.singletonInstance.get(key);
    }

    static async set(key: IDBValidKey, value: Record<string, unknown> | string | boolean | null): Promise<IDBValidKey> {
        return Database.singletonInstance.set(key, value);
    }

    static async delete(key: IDBValidKey): Promise<void> {
        return Database.singletonInstance.delete(key);
    }

    static async clear(): Promise<void> {
        return Database.singletonInstance.clear();
    }

    static async keys(): Promise<IDBValidKey[]> {
        return Database.singletonInstance.keys();
    }
}
